import { ModalOptimizationSummary } from '../../../../components/ModalOptimizationSummary';
import ChangePricesModalWrapper from './ChangePricesModalWrapper/ChangePricesModalWrapper';
import DeleteFilterModalWrapper from './DeleteFilterModal/DeleteFilterModalWrapper';
import DemandForecastModalWrapper from './DemandForecastModal/DemandForecastModalWrapper';
import PriceCompositionModalWrapper from './PriceManagerContextMenu/PriceComposition/PriceCompositionModalWrapper';
import PriceEventHistoryModalWrapper from './PriceManagerContextMenu/PriceEventHistory/PriceEventHistoryModalWrapper';
import RuleCompositionModalWrapper from './PriceManagerContextMenu/RuleComposition/RuleCompositionModalWrapper';
import RuleCompositionOfferModalWrapper from './PriceManagerContextMenu/RuleCompositionOffer/RuleCompositionOfferModalWrapper';
import SaveFiltersModalWrapper from './SaveFiltersModal/SaveFiltersModalWrapper';

export const ModalsWrapper = () => {
  return (
    <>
      <PriceCompositionModalWrapper />
      <RuleCompositionModalWrapper />
      <PriceEventHistoryModalWrapper />
      <RuleCompositionOfferModalWrapper />
      <DemandForecastModalWrapper />
      <SaveFiltersModalWrapper />
      <DeleteFilterModalWrapper />
      <ChangePricesModalWrapper />
      <ModalOptimizationSummary />
    </>
  );
};
